<template>
    <div>
        <v-simple-table class="v-data-table--no-hover">
            <tbody>
                <tr>
                    <th :rowspan="income.length + 2">수입내역</th>
                    <th>구분</th>
                    <th>결산</th>
                    <th>세부내용</th>
                </tr>
                <tr v-for="(item, index) in income" :key="`income-${index}`">
                    <td>{{ item.category }}</td>
                    <td>{{ item.amount.toLocaleString() }}</td>
                    <td>{{ item.detail }}</td>
                </tr>
                <tr>
                    <td>
                        <strong>총계</strong>
                    </td>
                    <td>
                        <strong>{{ totalIncome.toLocaleString() }}</strong>
                    </td>
                    <td />
                </tr>
            </tbody>
        </v-simple-table>

        <v-simple-table class="v-data-table--no-hover">
            <tbody>
                <tr>
                    <th :rowspan="expense.business.global.length + expense.business.local.length + expense.other.length + 3">지출내역</th>
                    <th colspan="2">구분</th>
                    <th>결산</th>
                    <th>세부내용</th>
                </tr>
                <tr v-for="(item, index) in expense.business.global" :key="`global-${index}`">
                    <th v-if="index == 0" :rowspan="expense.business.global.length">해외사업</th>
                    <td>{{ item.category }}</td>
                    <td>{{ item.amount.toLocaleString() }}</td>
                    <td>{{ item.detail }}</td>
                </tr>
                <tr v-for="(item, index) in expense.business.local" :key="`local-${index}`">
                    <th v-if="index == 0" :rowspan="expense.business.local.length">국내사업</th>
                    <td>{{ item.category }}</td>
                    <td>{{ item.amount.toLocaleString() }}</td>
                    <td>{{ item.detail }}</td>
                </tr>
                <tr>
                    <td colspan="2">
                        <span>사업비 합계</span>
                    </td>
                    <td>
                        <span>{{ totalBusinessExpense.toLocaleString() }}</span>
                    </td>
                    <td />
                </tr>
                <tr v-for="(item, index) in expense.other" :key="`other-${index}`">
                    <td colspan="2">{{ item.category }}</td>
                    <td>{{ item.amount.toLocaleString() }}</td>
                    <td>{{ item.detail }}</td>
                </tr>
                <tr>
                    <td colspan="2">
                        <strong>총계</strong>
                    </td>
                    <td>
                        <strong>{{ totalExpense.toLocaleString() }}</strong>
                    </td>
                    <td />
                </tr>
            </tbody>
        </v-simple-table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            // 수입내역
            income: [
                { category: "기타보조금", amount: 15294154, detail: "코이카 인큐베이팅" },
                { category: "재산수입", amount: 16800000, detail: "임대료" },
                { category: "사업수입", amount: 28509546, detail: "행복한 백화점" },
                { category: "잡수입", amount: 130489758, detail: "장애인고용장려금, 예금이자" },
                { category: "지정후원금", amount: 204732700, detail: "정기 및 일시후원" },
                { category: "비지정후원금", amount: 235108100, detail: "CMS, 일시후원, 해피빈" },
                { category: "이월금", amount: 450383795, detail: "통장 이월금" },
            ],

            // 지출내역
            expense: {
                // 사업 지출
                business: {
                    global: [{ region: "해외", category: "해외 사업 인큐베이팅 지원사업비", amount: 15294154, detail: "KOICA 연계 해외 사업 인큐베이팅" }],
                    local: [
                        { category: "복지사업비", amount: 35807350, detail: "지역연계 복지·나눔 프로그램 운영" },
                        { category: "교육사업비", amount: 12510620, detail: "종사자 교육 및 법인 기념행사" },
                        { category: "홍보네트웍사업비", amount: 531300, detail: "홍보물 제작 및 온라인 홍보" },
                        { category: "해외연수 및 워크숍 사업비", amount: 6000000, detail: "시설장·우수직원 역량강화 연수" },
                        { category: "대외교류협력사업비", amount: 415000, detail: "대외협력 행사 지원" },
                        { category: "기획연구사업비", amount: 4232700, detail: "2025 복지포럼 운영" },
                        { category: "자원개발관리사업비", amount: 10726860, detail: "후원자 발굴 및 나눔행사" },
                        { category: "나눔가게사업비", amount: 9562600, detail: "나눔가게 참여자 활동 지원" },
                    ],
                },

                // 기타 지출
                other: [
                    { category: "일반관리비", amount: 197973888, detail: "사무국 운영관리비" },
                    { category: "시설전출금", amount: 253904700, detail: "법인전입금" },
                    { category: "이월금(차년도 사업비)", amount: 534358881, detail: "차년도 사업수행 준비금" },
                ],
            },
        };
    },
    computed: {
        // 수입 총계
        totalIncome() {
            return this.income.reduce((sum, item) => {
                return sum + item.amount;
            }, 0);
        },
        // 사업 지출 총계
        totalBusinessExpense() {
            const globalSum = this.expense.business.global.reduce((sum, item) => sum + item.amount, 0);
            const localSum = this.expense.business.local.reduce((sum, item) => sum + item.amount, 0);
            return globalSum + localSum;
        },
        // 지출 총계
        totalExpense() {
            const otherSum = this.expense.other.reduce((sum, item) => sum + item.amount, 0);
            return this.totalBusinessExpense + otherSum;
        },
    },
};
</script>

<style lang="scss" scoped>
.v-data-table {
    border-top: 1px solid #111;
    border-bottom: 1px solid #111;
    border-radius: 0;
    th,
    td {
        border-right: 1px solid #ddd;
        text-align: center !important;
        font-size: 14px !important;
        word-break: keep-all;
        @media (min-width: 768px) {
            font-size: 18px !important;
        }
    }
    th {
        background-color: #f5f5f5;
    }
    td {
        > span,
        > strong {
            color: var(--v-primary-base);
        }
    }
}

.v-data-table + .v-data-table {
    margin-top: 40px;
    @media (min-width: 768px) {
        margin-top: 80px;
    }
}
</style>
